var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',[_c('MainMenu'),(_vm.userRoleName === 'admin' || _vm.userRoleName === 'superadmin')?_c('AdminPanel'):_vm._e(),_c('ComingSoon'),_c('SupportMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }